import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Papa from "papaparse";
import { useNavigate } from "react-router-dom";
import noImage from "../../no_Image.jpg";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import "../../index.css";

import {
  setSelectedCabling,
  deleteCabling,
  setFinalData,
  setTotalCablesSelected,
  setSelectedNumberOfDrops,
  updateCables2,
  updateComparisonData,
} from "../../../src/app/features/counter/counterSlice";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";

import { ProductCsvData } from "../fetchData/ProductCsvData.js";
import { ProductOptionsCsvData } from "../fetchData/ProductOptionsCsvData.js";

import { CloseFullscreen } from "@mui/icons-material";
import DisplayDrops from "./DisplayDrops.js";
import { toast } from "react-toastify";
import WarningComponent from "./WarningComponent.js";
import {
  calculateLineItem,
  getOptionEntries,
  mergeOptionPriceFields,
  getProductSku,
  getProductDisplayName,
} from "./quoteCalculator";

function Cabling() {
  const areYouDealer = useSelector((state) => state.counter1.areYouDealer);

  const whichOption = useSelector(
    (state) => state.counter1.whichOptionSelected
  );

  const selectedCameraNumber = useSelector(
    (state) => state.counter1.totalCamera
  );

  const totalNoOptions = useSelector((state) => state.counter1.totalNoOptions);

  const [totalDrops, setTotalDrops] = useState(0);

  const totalOfCablesNumbers = useSelector(
    (state) => state.counter1.totalCablesSelected
  );
  const [finalDatas, setFinalDatas] = useState([]);
  const [finalNewState2, setFinalNewState2] = useState({});
  const [editOn, setEditOn] = useState(null);
  const [disableIt, setDisableIt] = useState("");
  const [storeItem, setStoreItem] = useState({});
  const countCabling = useSelector((state) => state.counter1.selectedCabling);
  const { productOptionCSVQuery } = ProductOptionsCsvData();
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);

  const totalSelectedCameras = useSelector((state) => {
    const cameras = state.counter1.selectedCamera;
    const filteredCameras = cameras.filter(
      (item) => item.num_options === whichOption
    );
    let total = 0;
    filteredCameras.forEach((item) => {
      if (item.Product_Quantity) {
        total += item.Product_Quantity;
      }
    });
    return total;
  });

  const [count, setCount] = useState(
    totalDrops[whichOption] || totalSelectedCameras
  );

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [priceCab, setPriceCab] = useState(0);
  const [unitCostInput, setUnitCostInput] = useState("");
  const [updateVal, setUpdateVal] = useState();

  const [dataforProduct, setdataForProduct] = useState([]);
  const [basePrice, setBasePrice] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const dispatch = useDispatch();

  const [typedValue, setTypedValue] = useState(0);

  const [lgShow, setLgShow] = useState(false);
  const [showButtons, setShowButtons] = useState(null);
  const [showWarningComponent, setShowWarningComponent] = useState(false);
  React.useEffect(() => {
    setCartItems(countCabling || []);
    let totalPrice = 0;
    countCabling.forEach((item) => {
      totalPrice += item.totalPriceForItem;
    });
    setTotalPrice(totalPrice);
  }, [countCabling]);

  React.useEffect(() => {
    setCartItems(countCabling || []);
    let quantity = 0;
    countCabling.forEach((item) => {
      quantity += item.quantity;
    });
    setTotalQuantity(quantity);
  }, [countCabling]);

  React.useEffect(() => {
    dispatch(setTotalCablesSelected(totalQuantity));
  }, [totalQuantity]);

  const handlePlusClicks = () => {
    setCount(count + 1);
  };

  const handleMinusClicks = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  const handlePlusClickByFive = () => {
    setCount(count + 5);
  };

  const handleMinusClickByFive = () => {
    if (count > 5) {
      setCount(count - 5);
    }
  };

  const handlePlusClickByTen = () => {
    setCount(count + 10);
  };

  const handleMinusClickByTen = () => {
    if (count > 10) {
      setCount(count - 10);
    }
  };

  useEffect(() => {
    let priceCabling = (parseFloat(dataforProduct.price) + typedValue) * count;
    setPriceCab(priceCabling);
  }, [count, typedValue, dataforProduct.price]);

  const { productCSVQuery, isLoading2, isOnline2, isError2 } = ProductCsvData();
 
  //dpk update 
  // const cablingData = productCSVQuery
  //   ? productCSVQuery.filter((item) => {
  //     if (areYouDealer === "Dealer Selected") {
  //       if (item.hide_2 === "0") {
  //         return (
  //           item.categories && item.categories.includes("Hardware/Cabling")
  //         );
  //       }
  //     } else if (areYouDealer !== "Dealer Selected") {
  //       if (item.hide_1 === "0") {
  //         return (
  //           item.categories && item.categories.includes("Hardware/Cabling")
  //         );
  //       }
  //     }
  //   })
  //   : [];
 
  //knm update 
  const cablingData = productCSVQuery
  ? productCSVQuery.filter((item) => {
      return (
        item.categories && item.categories.includes("Hardware/Cabling")
      );
    })
  : [];

  function handleButtonClick(
    e,
    id,
    name,
    thumbnail,
    image1,
    image2,
    image3,
    type,
    item
  ) {

    // setEditOn(type)
    setShowButtons(type);
    setShow(true);
    setUpdateVal(cartItems.pricePerItem);
    const selectedProduct = productCSVQuery.find(
      (product) => product.id === id
    );
    setStoreItem(item);
    if (item?.quantity) {
      setCount(item.quantity);
    }

 if (type === "edit") {
    if (item?.quantity) {
      setCount(item.quantity);
    }
    setPriceCab(item.pricePerItem || 0);
    setUpdateVal(item.pricePerItem || 0);
    setTypedValue(item.typedValue || 0);
    
    // Calculate base price by subtracting typedValue from pricePerItem
    setBasePrice(item.pricePerItem - (item.typedValue || 0));
  } else {
    // For adding new, use default values
    setCount(totalDrops[whichOption] || totalSelectedCameras);
    const productPrice = areYouDealer !== "Dealer Selected" 
      ? selectedProduct.price 
      : selectedProduct.price_2;
    setPriceCab(parseFloat(productPrice));
    setUpdateVal(parseFloat(productPrice));
    setBasePrice(parseFloat(productPrice));
    setTypedValue(0);
  }

    // Find the product options based on product id
    let result = [];
    let currentArray = [];
    for (let i = 0; i < productOptionCSVQuery.length; i++) {
      const option = productOptionCSVQuery[i];
      if (
        option.productid === id ||
        (currentArray.length > 0 && option.productid === "")
      ) {
        currentArray.push(option);
      } else if (currentArray.length > 0) {
        result = currentArray;
        currentArray = [];
      }
    }
    if (currentArray.length > 0) {
      result = [...currentArray];
    }

    // Group the result by product id
    const result1 = [];
    let currentArray1 = [];
    for (let i = 0; i < result.length; i++) {
      const option = result[i];
      if (option.productid === id) {
        if (currentArray1.length > 0) {
          result1.push([...currentArray1]);
          currentArray1 = [];
        }
        currentArray1.push(option);
      } else if (currentArray1.length > 0 || i === result.length - 1) {
        currentArray1.push(option);
      }
    }

    if (currentArray1.length > 0) {
      result1.push([...currentArray1]);
    }

    setFinalDatas(result1);

    if (selectedProduct) {
      let finalState = {
        id: id,
        name: name,
        thumbnail: selectedProduct.thumbnail,
        image1: selectedProduct.image1,
        image2: selectedProduct.image2,
        image3: selectedProduct.image3,
        iamge4: selectedProduct.image4,
        price: areYouDealer !== "Dealer Selected" ? selectedProduct.price : selectedProduct.price_2
      };

      if (
        selectedProduct.extra_field_2 !== undefined &&
        selectedProduct.extra_field_2 !== ""
      ) {
        finalState = {
          ...finalState,
          drop: parseFloat(selectedProduct.extra_field_2),
        };
      }

      setdataForProduct(finalState);

      setBasePrice(parseFloat(selectedProduct.price) + typedValue);

      // const priceCabling =
      //   (parseFloat(selectedProduct.price) + typedValue) * count;

      // setPriceCab(priceCabling);
    }
  }

  useEffect(() => {
    const data = typedValue + (updateVal ? updateVal : basePrice);

    setPriceCab(data);
  }, [basePrice, count, typedValue]);

  const addButtonClick = () => {
    if (totalNoOptions === undefined) {
      return toast.error("No options available.");
    }

    setShow(false);

    const optionFields = mergeOptionPriceFields(finalNewState2, {
      "Cable Color": Number(finalNewState2["Cable Color_price"] || 0),
    });
    const previewCalc = calculateLineItem({
      pricePerItem: Number(priceCab || 0),
      quantity: count,
      ...optionFields,
    });
    const totalPriceForItem = previewCalc.unitTotal;
   
    let newItem = {
      num_options: whichOption,
      uniqueID: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
      id: dataforProduct.id,
      name: dataforProduct.name,
      quantity: count,
      pricePerItem: previewCalc.unitPrice,
      totalPriceForItem: totalPriceForItem,
      typedValue: typedValue,
      thumbnail: dataforProduct?.thumbnail || "",
      image1: dataforProduct?.image1 || "",
      image2: dataforProduct?.image2 || "",
      image3: dataforProduct?.image3 || "",
      image4: dataforProduct?.image4 || "",
    };

    // Add `drop` property if present in `dataforProduct`
    if (dataforProduct.drop !== undefined) {
      newItem = {
        ...newItem,
        drop: dataforProduct.drop,
      };
    }

    // Add selected option fields from `finalNewState2` if it has data
    if (Object.keys(optionFields).length > 0) {
      newItem = {
        ...newItem,
        ...optionFields,
      };
    }

    // Dispatch and update state
    dispatch(setSelectedCabling(newItem));
    dispatch(setFinalData(newItem));
    setCartItems((prevCartItems) => [...prevCartItems, newItem]);
    setTotalPrice((prevTotalPrice) => prevTotalPrice + totalPriceForItem);
    setTotalQuantity((prevTotalPrice) => prevTotalPrice + count);
    setCount(totalDrops[whichOption] || totalSelectedCameras);
    setTypedValue(0);
    setTotalDrops(0);
  };

  const handleClose = () => {
    setShow(false);
    setCount(totalDrops[whichOption] || totalSelectedCameras);
  };

  const handleDelete = (name, option, uniqueID) => {
    
    dispatch(deleteCabling({ name, option, uniqueID }));
    const findIndex = countCabling.findIndex(
      (item) => item.id === name && item.num_options === option
    );
    const updatedCartItems = [...cartItems];
    const itemToRemove = updatedCartItems[findIndex];
    const newTotalPrice = totalPrice - itemToRemove?.totalPriceForItem;
    const TotalQuantity = totalQuantity - itemToRemove?.quantity;
    const updatedCart = updatedCartItems.filter(
      (item) => !(item.id === name && item.num_options === option)
    );
    setCartItems(updatedCart);
    setTotalPrice(newTotalPrice);
    setTotalQuantity(TotalQuantity);
    setTotalDrops(0);
  };


  function updateCable() {
    setUpdateVal(cartItems.pricePerItem);
    const optionFields = mergeOptionPriceFields(finalNewState2, {
      "Cable Color": Number(finalNewState2["Cable Color_price"] || 0),
    });
    const previewCalc = calculateLineItem({
      pricePerItem: Number(priceCab || 0),
      quantity: count,
      ...optionFields,
    });
    const totalPriceForItem = previewCalc.unitTotal;

    // console.log(dataforProduct)
    // let newItem2 = {
    //   id: dataforProduct.id,
    //   name: dataforProduct.name,
    //   quantity: count,
    //   pricePerItem: basePrice + typedValue,
    //   totalPriceForItem: totalPriceForItem,
    //   typedValue: typedValue,
    //   "Cable Color": storeItem["Cable Color"],
    //   "Cable Color_price": storeItem["Cable Color_price"],
    // };
    let newItem2 = {
      ...optionFields,
      num_options: whichOption,
      uniqueID: storeItem.uniqueID,
      id: dataforProduct.id,
      name: dataforProduct.name,
      quantity: count,
      pricePerItem: previewCalc.unitPrice,
      totalPriceForItem: totalPriceForItem,
      typedValue: typedValue,
      thumbnail: dataforProduct?.thumbnail || "",
      image1: dataforProduct?.image1 || "",
      image2: dataforProduct?.image2 || "",
      image3: dataforProduct?.image3 || "",
      image4: dataforProduct?.image4 || "",
    };
    // newItem2 = storeItem;
    if (dataforProduct.drop !== undefined) {
      newItem2 = {
        ...newItem2,
        drop: dataforProduct.drop,
      };
    }

    dispatch(updateCables2(newItem2));
    setTypedValue(0);
    setCount(totalDrops[whichOption] || totalSelectedCameras);
    setShow(false);
    setTotalDrops(0);
  }

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*(\.\d{0,2})?$/.test(value)) {
      setUnitCostInput(value);
      const numericValue = value === "" || value === "." ? 0 : parseFloat(value);
      setUpdateVal(numericValue);
      setPriceCab(numericValue);
    }
  };

  const typedIncrement = () => {
    setUnitCostInput("");
    setUpdateVal(priceCab + 1);
    setPriceCab((prev) => prev + 1);
  };

  const typedDecrement = () => {
    setUnitCostInput("");
    setUpdateVal(priceCab - 1);
    setPriceCab((prev) => prev - 1);
  };

  const filterData = cartItems.filter(
    (item) => item.num_options === whichOption
  );

  useEffect(() => {
    setCount(totalDrops[whichOption] || totalSelectedCameras);
  }, [totalDrops, whichOption]);

  const accessDrops = (drop) => {
    setTotalDrops(drop);
  };

  useEffect(() => {
    let numberOfCables = 0;

    filterData.forEach((item) => {
      numberOfCables += item?.quantity;
    });

    if (whichOption && totalNoOptions !== undefined) {
      dispatch(
        updateComparisonData({
          [whichOption]: {
            name: "cables",
            quantity: numberOfCables || 0,
            warning: totalDrops[whichOption] || totalSelectedCameras,
            option: whichOption,
            navigationName: "/cabling",
          },
        })
      );
    }
  }, [filterData]);

  //***** Below Code is responsible for filling finalNewState-2 *******//
  useEffect(() => {
    const initialSelectedOptions = {};
    if (editOn === "edit") {
      // Loop through all possible options (1 to 6)
      for (let i = 1; i <= 6; i++) {
        const optionNameKey = `option${i}_name`;
        const optionValueKey = `option${i}_value`;
        const optionPriceKey = `option${i}_price`;

        // Check if the option exists on the storeItem
        if (storeItem[optionNameKey] && storeItem[optionValueKey]) {
          // Add option name and value to initialSelectedOptions
          initialSelectedOptions[storeItem[optionNameKey]] =
            storeItem[optionValueKey];

          // Add price with the correct option name and '_price' suffix
          initialSelectedOptions[storeItem[optionNameKey] + "_price"] =
            storeItem[optionPriceKey];
        }


      }
    } else {
      finalDatas.forEach((item) => {
        if (item.length > 0) {
          const firstOption = item[0];
          initialSelectedOptions[firstOption.featurecaption] =
            firstOption.featurename;
          initialSelectedOptions[firstOption.featurecaption + "_price"] =
            firstOption.featureprice;
        }
      });
    }
    setFinalNewState2(initialSelectedOptions);
  }, [finalDatas]);

  //***** Below Code is responsible for filling finalNewState-2 *******//

  //************************** HandleChange ***************************//

  function handleSelectChange(e) {
    const { name, value } = e.target;
    const selectedOption = finalDatas
      .flat()
      .find((option) => option.featurename === value);
    setDisableIt(selectedOption.featurename);

    // setFinalNewState2((prevState) => ({
    //   ...prevState,
    //   [name]: value,
    // }));

    const prevOptionPrice =
      finalNewState2[name] &&
        finalDatas
          .flat()
          .find((option) => option.featurename === finalNewState2[name])
        ? parseFloat(
          finalDatas
            .flat()
            .find((option) => option.featurename === finalNewState2[name])
            .featureprice
        )
        : 0;

    const optionPrice = selectedOption
      ? parseFloat(selectedOption.featureprice)
      : 0;

    const priceDifference = optionPrice - prevOptionPrice;

    setTotalPrice((prevTotalPrice) => prevTotalPrice + priceDifference);

    setStoreItem((prevData) => ({
      ...prevData,
      [name]: value,
      [name + "_price"]: optionPrice,
    }))
    setFinalNewState2((prevData) => ({
      ...prevData,
      [name]: value,
      [name + "_price"]: optionPrice,
    }));
  }

  return (
    <>
      <Container fluid className="my-4" style={{ backgroundColor: "" }}>
        <Container className="navbar_margin">
          <Row style={{ backgroundColor: "" }}>
            <Col style={{ backgroundColor: "" }} className="marginTopSpace">
              <h2>
                Cables <span className="fst-italic fs-6">(Category)</span>
              </h2>
            </Col>

            <Col className="marginTopSpace" style={{ backgroundColor: "" }}>
              <Row>
                <Col className="text-end">
                  Total Cameras Selected:
                  <span className="fw-bold">{totalSelectedCameras}</span>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col className="text-end">
                  Total number of drops : { }
                  <span className="fw-bold">
                    {totalDrops[whichOption] === undefined
                      ? 0
                      : totalDrops[whichOption] === 0
                        ? totalSelectedCameras
                        : totalDrops[whichOption]}
                  </span>
                  {totalDrops === 0 ? (
                    <DisplayDrops
                      accessDrops={accessDrops}
                      runAccessDrops={"runAccessDrops"}
                    />
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="" style={{ padding: "8px" }}>
            <Col>
              <h5 className="fw-bold">Add to Cart: </h5>

              <div className="table-border">
                <Table striped bordered hover responsive>
                  <colgroup>
                    <col style={{ width: "160px" }} />
                    <col style={{ width: "auto" }} />
                    <col style={{ width: "110px" }} />
                    <col style={{ width: "80px" }} />
                    <col style={{ width: "120px" }} />
                    <col style={{ width: "90px" }} />
                    <col style={{ width: "90px" }} />
                  </colgroup>
                  <thead>
                    <tr>

                      <th>SKU</th>
                      <th>Description & Options</th>
                      <th>Price</th>
                      <th>QTY</th>
                      <th>Total</th>
                      <th colSpan={2} className="text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterData.map((item, index) => {
                      const uniqueKey = `${index}-${item.id}`;
                      const calc = calculateLineItem(item, {
                        optionUnitTotal:
                          item["Cable Color_price"] !== undefined
                            ? Number(item["Cable Color_price"] || 0)
                            : undefined,
                      });

                      return (
                        <tr key={uniqueKey}>

                          <td style={{ whiteSpace: "nowrap" }}>{getProductSku(item)}</td>
                          <td>
                            {item.name ? (
                              <>
                                <strong>{getProductDisplayName(item)}</strong>
                                <br />
                              </>
                            ) : null}
                            {getOptionEntries(item).map((option) => (
                              <React.Fragment key={option.name}>
                                <strong>{option.name}:</strong>{" "}
                                {option.value}{" "}
                                <strong>
                                  ${Number(option.price || 0).toFixed(2)}
                                </strong>
                                <br />
                              </React.Fragment>
                            ))}
                          </td>
                          <td>${calc.unitTotal.toFixed(2)}</td>
                          <td>{item.quantity}</td>
                          <td>${calc.lineTotal.toFixed(2)}</td>

                          <td>
                            <Button
                              variant="dark"
                              className="mx-4"
                              onClick={(e) =>
                                handleButtonClick(
                                  e,
                                  item.id,
                                  item.name,
                                  item.thumbnail,
                                  item.image1,
                                  item.image2,
                                  item.image3,
                                  "edit",
                                  item
                                )
                              }
                            >
                              Edit
                            </Button>
                          </td>
                          <td>
                            <Button
                              variant="dark"
                              onClick={() =>
                                handleDelete(item.id, item['Cable Color'], item.uniqueID)
                              }
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>

          <div className="d-flex justify-content-end align-items-center">
            {showWarningComponent ? (
              <WarningComponent
                path="/labor"
                setShowWarningComponent={setShowWarningComponent}
              />
            ) : (
              ""
            )}
            <Button
              variant="dark"
              onClick={() => setShowWarningComponent(true)}
            >
              Next
            </Button>
          </div>

          {/* Box*/}
          <Row className="my-4">
            {cablingData?.sort((a, b) => parseInt(a.sorting) - (b.sorting)).map((val, index) => {
              const unique = `${val.id}-${index}`;
              return (
                <Col
                  key={unique}
                  style={{ backgroundColor: "" }}
                  md={4}
                  className="nvr_col my-3"
                  onClick={(e) =>
                    handleButtonClick(
                      e,
                      val.id,
                      val.name,
                      val.thumbnail,
                      val.image1,
                      val.image2,
                      val.image3,
                      "add"
                    )
                  }
                >
                  <Card style={{ width: "", margin: "", height: "auto" }}>
                    <Card.Body>
                      <Card.Title className="fw-bold">
                        SKU : {val.id}
                      </Card.Title>
                      <Card.Text className="cableName">
                        {val.name.split(" ").length > 12
                          ? `${val.name.split(" ").slice(0, 12).join(" ")}...`
                          : val.name}
                      </Card.Text>
                      <Row
                        style={{
                          height: "185px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Col xs={8}>
                          <Card.Img
                            variant="top"
                            style={{
                              width: "100%",
                              height: "100%",
                              maxHeight: "200px",
                              objectFit: "contain",

                              // aspectRatio: "1",
                              border: "0px solid grey",
                            }}
                            src={
                              val.thumbnail === ""
                                ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                                : "https://platinumcctv.com/" + val.thumbnail
                            }
                          />
                        </Col>
                        <Col
                          xs={4}
                          className="d-flex align-items-center justify-content-center fw-bold"
                        >
                          ${areYouDealer !== "Dealer Selected" ? val.price : val.price_2}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Container>
      </Container>

      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>{dataforProduct.id}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md={4}>
                <Row>
                  <Card.Img
                    variant="top"
                    height={150}
                    src={
                      dataforProduct.thumbnail === ""
                        ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                        : "https://platinumcctv.com/" + dataforProduct.thumbnail
                    }
                  />
                </Row>
                <Row className="my-2">
                  <Col>
                    <Card.Img
                      variant="top"
                      height={50}
                      src={
                        dataforProduct.image1 === ""
                          ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                          : "https://platinumcctv.com/" + dataforProduct.image1
                      }
                    />
                  </Col>

                  <Col>
                    <Card.Img
                      variant="top"
                      height={50}
                      src={
                        dataforProduct.image2 === ""
                          ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                          : "https://platinumcctv.com/" + dataforProduct.image2
                      }
                    />
                  </Col>
                  <Col>
                    <Card.Img
                      variant="top"
                      height={50}
                      src={
                        dataforProduct.image3 === ""
                          ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                          : "https://platinumcctv.com/" + dataforProduct.image3
                      }
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={8}>
                <p className="fst-italic">
                  <span className="fw-bold">Description: </span>
                  {dataforProduct.name}
                </p>
                {/* Add Dropdown */}
                {finalDatas.map((item, itemIndex) => (
                  <div key={itemIndex} className="CableOption">
                    <Form.Label>{item[0].featurecaption}</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      className="mb-3 "
                      name={item[0].featurecaption}
                      defaultValue={storeItem?.[item[0].featurecaption] || ""}
                      onChange={handleSelectChange}
                    >
                      {item.map((option, optionIndex) => (
                        <option key={optionIndex} value={option.featurename}  >
                          {`${option.featurename} $${option.featureprice}`}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                ))}

                <div className="d-flex align-items-end justify-content-between my-4 ">
                  Qty :
                  <Button variant="dark" onClick={handleMinusClickByTen}>
                    -10
                  </Button>
                  <Button variant="dark" onClick={handleMinusClickByFive}>
                    -5
                  </Button>
                  <Button variant="dark" onClick={handleMinusClicks}>
                    -
                  </Button>
                  <h6 className="mx-3">{count}</h6>
                  <Button variant="dark" onClick={handlePlusClicks}>
                    +
                  </Button>
                  <Button variant="dark" onClick={handlePlusClickByFive}>
                    +5
                  </Button>
                  <Button variant="dark" onClick={handlePlusClickByTen}>
                    +10
                  </Button>
                </div>

                <div className=" d-flex align-items-center justify-content-end">
                  Unit Cost :
                  <InputGroup className="mb-3">
                    <Button
                      onClick={typedDecrement}
                      variant="dark"
                      className="mx-3"
                    >
                      -
                    </Button>
                    <Form.Control
                      type="text"
                      value={unitCostInput !== "" ? unitCostInput : priceCab}
                      onFocus={() => setUnitCostInput(String(priceCab ?? ""))}
                      onBlur={() => setUnitCostInput("")}
                      onChange={handleInputChange}
                    />
                    <Button
                      onClick={typedIncrement}
                      variant="dark"
                      className="mx-3"
                    >
                      +
                    </Button>
                  </InputGroup>
                </div>
                <hr />

                {/* Total Cost Div*/}
                <div className="mt-4 d-flex align-items-center justify-content-end">
                  <h6>
                    Total Cost :
                    <b>
                      {(() => {
                        const calc = calculateLineItem(
                          {
                            pricePerItem: Number(priceCab || 0),
                            quantity: count,
                            ...mergeOptionPriceFields(finalNewState2, {
                              "Cable Color": Number(
                                finalNewState2["Cable Color_price"] || 0
                              ),
                            }),
                          }
                        );
                        return `$${calc.lineTotal
                          .toFixed(2)
                          .replace(/\.?0+$/, "")}`;
                      })()}
                    </b>
                  </h6>
                </div>
              </Col>
            </Row>
            <Row className="mt-5 justify-content-start">
              <div className="w-100 my-1 d-flex justify-content-start">
                <div className="text">
                  <Table
                    striped
                    bordered
                    hover
                    responsive
                    style={{ width: "14rem" }}
                  ></Table>
                </div>
              </div>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button variant="dark" onClick={() => setShow(false)}>
            Back
          </Button>

          {showButtons === "edit" ? (
            <Button variant="dark" onClick={updateCable}>
              Update Item
            </Button>
          ) : (
            <Button variant="dark" onClick={addButtonClick}>
              Add
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Warning Modal*/}

      <Modal show={lgShow} onHide={() => setLgShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>Warning: Cables and drops are not equivalent.</h6>
          </Modal.Title>
        </Modal.Header>

        {/* <Modal.Body>Are you sure you want to continue?</Modal.Body> */}

        <Modal.Footer>
          <Button variant="dark" onClick={() => setLgShow(false)}>
            Continue Adding Cables
          </Button>

          <Button variant="dark" onClick={() => navigate("/labor")}>
            Move to Labor Section
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default Cabling;
